/*!
 * JM Bead Metal v1.0 — optional per-metal bead layouts for the Unity link beads (necklace / bracelet).
 * custom.bead_preview.render.layouts = { "gold": { "4": [[x, y, r, angle], …], … }, "silver": { … } }  (same format as cfg.beads)
 * Wraps JMBeadRender.draw: when a layout exists for the chosen metal and number of beads, it is used instead of cfg.beads[n].
 * Products without render.layouts (the necklace) are untouched. Loaded after jm-bead-render.js and before jm-name-preview.js.
 */
(function () {
  'use strict';
  var R = window.JMBeadRender;
  if (!R || !R.draw || R.__metal) return;
  var base = R.draw;
  R.draw = function (cv, img, beads, names, metal, opts) {
    var L = opts && opts.layouts && opts.layouts[metal] && opts.layouts[metal][String(beads.length)];
    return base.call(R, cv, img, L || beads, names, metal, opts);
  };
  R.__metal = true;
})();
